/* Free-shipping threshold in the visitor's currency for every element .bmx2-fs[data-eur] (cart drawer, cart page,
   product pages). Threshold = automatic discount "Free Shipping" (45 EUR since 2026-10-19), converted at Shopify's
   market rate and rounded UP to a locally round amount so the shown amount always qualifies. */
(function () {
  var STEP = { PLN: 5, CZK: 50, HUF: 500, RON: 5, SEK: 10, DKK: 5, GBP: 5, BGN: 5, USD: 5, CHF: 5, NOK: 10 };
  function run(root) {
    try {
      var cur = window.Shopify && Shopify.currency;
      if (!cur || !cur.active || cur.active === 'EUR') return;
      var rate = parseFloat(cur.rate) || 0;
      (root || document).querySelectorAll('.bmx2-fs[data-eur]:not([data-done])').forEach(function (el) {
        var eur = parseFloat(el.getAttribute('data-eur'));
        // UK has its own GBP price list (Shopify reports rate 1.0); 45 EUR is just under 40 GBP.
        var raw = cur.active === 'GBP' && rate === 1 ? 40 : eur * rate;
        if (!raw) return;
        var step = STEP[cur.active] || 1;
        el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur.active, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.ceil(raw / step) * step);
        el.setAttribute('data-done', '1');
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  // cart drawer and cart sections are re-rendered via AJAX
  new MutationObserver(function () { run(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
